import { Delete, Edit } from "@material-ui/icons";
import React, { useState } from "react";
import "./Todo.css";

function Todo({ todo, remove, update }) {
  const [isEditing, setIsEditing] = useState(false);
  const [task, setTask] = useState(todo.textTask);
  const handleClick = () => {
    remove(todo.id, task);
  };
  const toggleFrom = () => {
    setIsEditing(!isEditing);
  };
  const handleUpdate = (evt) => {
    evt.preventDefault();
    update(todo.id, task);
    toggleFrom();
  };
  const handleChange = (evt) => {
    setTask(evt.target.value);
  };

  let result;
  if (isEditing) {
    result = (
      <div className="Todo">
        <form className="Todo-edit-form" onSubmit={handleUpdate}>
          <input onChange={handleChange} value={task} type="text" />
          <button>Save</button>
        </form>
      </div>
    );
  } else {
    result = (
      <div className="Todo">
        <li id={todo.id} className={"Todo-task"}>
          {todo.textTask}
        </li>
        <div className="Todo-buttons">
          <button onClick={toggleFrom}>
            <Edit />
          </button>
          <button onClick={handleClick}>
            <i id={todo.id} className="fas fa-trash" />
            <Delete />
          </button>
        </div>
      </div>
    );
  }
  return result;
}

export default Todo;
